import { energyFormParametersGeneration } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Contract/Energy/energyFormParametersGeneration'
import { contractSaveParametersGeneration as contractSaveParametersGenerationBeEnergy } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Contract/Energy/BE/contractSaveParametersGeneration'
import { contractSaveParametersGeneration as contractSaveParametersGenerationItEnergy } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Contract/Energy/IT/contractSaveParametersGeneration'
import * as Sentry from '@sentry/react'
import { contractSaveParametersGeneration as contractSaveParametersGenerationFrTelecom } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Contract/Telecom/FR/contractSaveParametersGeneration'
import { contractSaveParametersGeneration as contractSaveParametersGenerationBeTelecom } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Contract/Telecom/BE/contractSaveParametersGeneration'
import { contractSaveParametersGeneration as contractSaveParametersGenerationItTelecom } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Contract/Telecom/IT/contractSaveParametersGeneration'
import { contractSaveParametersGeneration as contractSaveParametersGenerationBeInsurance } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Contract/Insurance/BE/contractSaveParametersGeneration'
import { contractSaveParametersGeneration as contractSaveParametersGenerationFrInsurance } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Contract/Insurance/FR/contractSaveParametersGeneration'

const parametersGeneratorByCountryAndVertical = {
  'be-energy': contractSaveParametersGenerationBeEnergy,
  'be-insurance': contractSaveParametersGenerationBeInsurance,
  'be-telecom': contractSaveParametersGenerationBeTelecom,
  'fr-energy': energyFormParametersGeneration,
  'fr-insurance': contractSaveParametersGenerationFrInsurance,
  'fr-telecom': contractSaveParametersGenerationFrTelecom,
  'it-energy': contractSaveParametersGenerationItEnergy,
  'it-telecom': contractSaveParametersGenerationItTelecom,
  'nl-energy': energyFormParametersGeneration,
  'de-energy': energyFormParametersGeneration,
  'at-energy': energyFormParametersGeneration,
}

export function generateParameters({
  type,
  country,
  contractId,
  contactId,
  addressId,
  billingAddressId,
  residenceAddressId,
  contractData,
  characteristicsData,
  contactPreferences,
  action,
  contractAddressData,
  electricityMeterData,
  gasMeterData,
  propaneData,
  billingData,
  energyConsumptionData,
}) {
  const generatorKey = `${country}-${type}`
  const generator = parametersGeneratorByCountryAndVertical[generatorKey] ?? null

  if (generator) {
    return generator({
      type,
      contractId,
      contactId,
      addressId,
      billingAddressId,
      residenceAddressId,
      contractData,
      characteristicsData,
      mainAddressData: contractAddressData,
      contactPreferences,
      electricityMeterData,
      billingData,
      gasMeterData,
      energyConsumptionData,
      action,
      propaneData,
    })
  }

  if (import.meta.env.PROD) {
    Sentry.captureException(new Error(`generateParameters: Unknown business vertical type '${type}'`), {
      extra: { type },
    })
  }
  throw new Error(`generateParameters: Unknown business vertical type '${type}'`)
}
